import { ColumnMapping } from 'api'
import { isNil, isUndefined } from 'lodash'
import { Result, NullResult, ErrorResult, ValueResult } from 'utils'
import { SpreadsheetParseError } from './utils'

interface CreateParseCellOptions<T = any> {
  resultTransform: (v: T) => T
}

const defaultOptions: CreateParseCellOptions = {
  resultTransform: (v: any) => v
}

export const createParseCell = ({ resultTransform }: CreateParseCellOptions = defaultOptions) => (
  row: any,
  rowNum: number,
  columnMapping: ColumnMapping,
  fieldName: string,
  mandatory: boolean
): Result<any> => {
  if (isNil(columnMapping.heading)) {
    return NullResult
  } else if (isUndefined(row[columnMapping.heading]) && mandatory) {
    return new ErrorResult(new SpreadsheetParseError(`Column "${columnMapping.heading}" is missing`, rowNum, fieldName))
  } else {
    return new ValueResult(resultTransform(row[columnMapping.heading]) ?? null, fieldName)
  }
}

export const parseCell = createParseCell()
